import { render } from "./toDoDelay.vue?vue&type=template&id=3982dd62&scoped=true"
import script from "./toDoDelay.vue?vue&type=script&lang=js"
export * from "./toDoDelay.vue?vue&type=script&lang=js"

import "./toDoDelay.vue?vue&type=style&index=0&id=3982dd62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3982dd62"]])

export default __exports__